import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IMealtime } from 'src/types/mealtimes.types';
import { IUpdateMealtimeDetailsRequest, IUpdateMealtimeResponse } from './types';

export const updateMealtimeDetails = async (
  menuId: string,
  mealtimeId: string,
  requestBody: IUpdateMealtimeDetailsRequest,
): Promise<IMealtime> => {
  const response = await fetch(`${API_URL}/menus/${menuId}/mealtimes/${mealtimeId}`, {
    method: 'PATCH',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (response.status !== Status.SUCCESS) {
    throw new Error('Something went wrong whilst updating a mealtime');
  }

  const { data }: IUpdateMealtimeResponse = await response.json();
  return data[0];
};
